import { ViewDto } from '../../../../types/dto/ViewDto';
import { View } from '../../../../types/View';

export const mapViewDtoToView = (views: ViewDto[]): View[] => views.map(({Name, DisplayName, DateCreated, RequestAccess}) =>
  ({ name: Name, displayName: DisplayName, dateCreated: new Date(DateCreated).getTime(), requestAccess: RequestAccess }));
